import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../Zitadel-Auth/Auth.css';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [devData, setDevData] = useState<{ userId: string; code: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!username) {
      setError('Username is required');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth/custom/forgot-password`,
        { username }
      );

      setSuccess(true);

      // In development mode, show the code
      if (response.data.devCode && response.data.devUserId) {
        setDevData({
          userId: response.data.devUserId,
          code: response.data.devCode,
        });
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to request password reset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Forgot Password</h1>
          <p>Enter your username to receive a password reset code</p>
        </div>

        {error && <div className="error-message">{error}</div>}
        {success && (
          <div className="success-message">
            <p>If a user with that username exists, a password reset email has been sent.</p>
            {devData && (
              <div style={{ marginTop: '15px', padding: '10px', background: '#f0f0f0', borderRadius: '5px' }}>
                <p><strong>Development Mode</strong></p>
                <p>User ID: <code>{devData.userId}</code></p>
                <p>Reset Code: <code>{devData.code}</code></p>
                <button
                  onClick={() => navigate(`/reset-password?userId=${devData.userId}&code=${devData.code}`)}
                  className="submit-button"
                  style={{ marginTop: '10px' }}
                >
                  Go to Reset Password →
                </button>
              </div>
            )}
          </div>
        )}

        {!success && (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setError('');
                }}
                placeholder="Enter your username"
                disabled={loading}
                autoFocus
                required
              />
            </div>

            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Code'}
            </button>

            <button
              type="button"
              onClick={() => navigate('/login')}
              className="back-button"
              disabled={loading}
              style={{ marginTop: '10px' }}
            >
              ← Back to Login
            </button>
          </form>
        )}

        {success && !devData && (
          <button
            onClick={() => navigate('/login')}
            className="submit-button"
            style={{ marginTop: '15px' }}
          >
            Back to Login
          </button>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
